import React from 'react';
import { LoadingWrapper } from '../loading';
import StatsCards from '../common/statsCard';

const FinanceStatsCards = ({ statsCards, isLoading }) => (
  <LoadingWrapper
    isLoading={isLoading}
    loadingType="skeleton"
    skeletonCount={statsCards?.length || 4}
    gridProps={{ xs: 12, sm: 6, md: 3 }}
    containerSx={{ marginY: 3 }}
  >
    <StatsCards stats={statsCards} />
  </LoadingWrapper>
);

export default FinanceStatsCards;
